import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { DELE_SECTIONS } from './sections';
import { deleScoringRules } from './scoring';
import { DELE_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * DELE 考试完整配置
 */
export const deleExamConfig: ExamTypeConfig = {
  id: 'dele',
  name: 'DELE (Diplomas de Español como Lengua Extranjera)',
  description: 'DELE 是西班牙官方认证的西班牙语水平证书，由塞万提斯学院颁发',
  languageId: 'spanish',
  questionTypeDefinitions: DELE_QUESTION_TYPE_DEFINITIONS,
  sections: DELE_SECTIONS,
  scoringRules: deleScoringRules,
};

registerExamQuestionTypes('dele', Object.values(DELE_QUESTION_TYPE_DEFINITIONS));

export * from './types';
export * from './levels';
export * from './sections';
export * from './scoring';
export * from './intro';
export * from './questionTypes';
